export enum ImageType {
  Spinner = 'Spinner',
  Success = 'Success',
  Error = 'Error',
}
